import { HierarchyManager } from "../../components/HierarchyManager/index.js";
import { miscellaneousConfig } from "./miscellaneousConfig.js";

function MiscellaneousPage() {
  return <HierarchyManager config={miscellaneousConfig} />;
}

export default MiscellaneousPage;
